import { render, staticRenderFns } from "./QuickUser.vue?vue&type=template&id=5ae032cc&scoped=true"
import script from "./QuickUser.vue?vue&type=script&lang=js"
export * from "./QuickUser.vue?vue&type=script&lang=js"
import style0 from "./QuickUser.vue?vue&type=style&index=0&id=5ae032cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae032cc",
  null
  
)

export default component.exports